import { useEffect, useState } from 'react';
import { api } from './api';

// Admin-editable site texts. Each field: [key, label, default, multiline?]. Use "\n" for a line break.
export const SITE_TEXT_GROUPS = [
    { title: 'Home — Hero buttons', fields: [
        ['home.hero.cta1', 'Main button', 'Shop Equipment'],
        ['home.hero.cta2', 'Second button', 'Get a Machine Quote'],
    ] },
    { title: 'Home — Industries strip (scrolling)', fields: [
        ['home.marquee', 'Industries (one per line)', 'AEROSPACE\nAUTOMOTIVE\nFOOD & BEVERAGE\nPOWER GENERATION\nPRINTING\nMARINE\nMANUFACTURING\nHISTORIC RESTORATION\nPLASTIC & INJECTION MOLDING\nELECTRICAL', true],
    ] },
    { title: 'Home — Featured equipment', fields: [
        ['home.featured.eyebrow', 'Small label', '/ 01 — Shop equipment'],
        ['home.featured.heading', 'Heading', 'Featured\nequipment', true],
    ] },
    { title: 'Home — Shop by category', fields: [
        ['home.cats.eyebrow', 'Small label', '/ 02 — Shop by category'],
        ['home.cats.heading', 'Heading', 'Everything you need'],
        ['home.cats.accent', 'Heading (orange part)', 'to blast with dry ice.'],
        ['home.cats.machines.title', 'Tile 1 title', 'Dry Ice Machines'],
        ['home.cats.machines.text', 'Tile 1 text', 'Blasters for detailing, light industrial and heavy production work.', true],
        ['home.cats.accessories.title', 'Tile 2 title', 'Accessories & Parts'],
        ['home.cats.accessories.text', 'Tile 2 text', 'Nozzles, hoses, guns and wear parts — buy online, shipped fast.', true],
        ['home.cats.used.title', 'Tile 3 title', 'Used Equipment'],
        ['home.cats.used.text', 'Tile 3 text', 'Inspected, serviced pre-owned machines at a lower entry price.', true],
        ['home.cats.support.title', 'Tile 4 title', 'Service & Repairs'],
        ['home.cats.support.text', 'Tile 4 text', 'Repairs, tune-ups and a support line that answers within 24h.', true],
    ] },
    { title: 'Home — Industries we equip', fields: [
        ['home.ind.eyebrow', 'Small label', '/ 03 — Industries we equip'],
        ['home.ind.heading', 'Heading', 'Built for demanding\nindustrial operations.', true],
        ['home.ind.list', 'Industries (one per line)', 'Aerospace\nAutomotive\nFood & Beverage\nManufacturing\nInjection Molding\nPower Generation\nMarine\nPrinting\nPlastics\nElectrical', true],
    ] },
    { title: 'Home — Why choose us', fields: [
        ['home.why.eyebrow', 'Small label', '/ 04 — Why choose us'],
        ['home.why.heading', 'Heading', 'Why operators buy'],
        ['home.why.accent', 'Heading (orange part)', 'from us.'],
        ['home.why.1.title', 'Point 1 title', 'Field-Proven Advice'],
        ['home.why.1.text', 'Point 1 text', 'We have run these machines on real jobs — we recommend the setup that fits your work.', true],
        ['home.why.2.title', 'Point 2 title', 'Training Included'],
        ['home.why.2.text', 'Point 2 text', 'Operator training and certification so your team gets results from day one.', true],
        ['home.why.3.title', 'Point 3 title', 'Industrial Experience'],
        ['home.why.3.text', 'Point 3 text', 'Decades of surface treatment experience across aerospace, automotive, food, and heavy industry.', true],
        ['home.why.4.title', 'Point 4 title', 'Service After the Sale'],
        ['home.why.4.text', 'Point 4 text', 'Parts, repairs and a support line that answers within 24 hours.', true],
    ] },
    { title: 'Home — Rental & training', fields: [
        ['home.rental.eyebrow', 'Small label', '/ Rental & training'],
        ['home.rental.heading', 'Heading', 'Try before you buy.'],
        ['home.rental.accent', 'Heading (orange part)', 'Rent it, learn it.'],
        ['home.rental.text', 'Text', 'Rent a professional dry ice blaster by the day or week for a job or a trial run, and get operator training built around your team — on-site or remote.', true],
        ['home.rental.training', 'Training link', 'Training & certification'],
        ['home.rental.cta', 'Button', 'See all rental machines & rates'],
    ] },
    { title: 'Home — Before / after', fields: [
        ['home.ba.eyebrow', 'Small label', '/ See the difference'],
        ['home.ba.heading', 'Heading', 'Industrial customers'],
        ['home.ba.accent', 'Heading (orange part)', 'buy proof.'],
        ['home.ba.text', 'Text', 'Drag the divider to see real cleaning results — same equipment, same day.', true],
    ] },
    { title: 'Home — Projects, videos & news', fields: [
        ['home.projects.eyebrow', 'Projects small label', '/ Recent industrial projects'],
        ['home.projects.heading', 'Projects heading', 'Real jobs.'],
        ['home.projects.accent', 'Projects heading (orange part)', 'Real proof.'],
        ['home.videos.eyebrow', 'Videos small label', '/ In action'],
        ['home.videos.heading', 'Videos heading', 'See the work'],
        ['home.news.eyebrow', 'News small label', '/ Latest'],
        ['home.news.heading', 'News heading', 'News & insights'],
    ] },
    { title: 'Home — Partner map', fields: [
        ['home.partners.eyebrow', 'Small label', '/ Partner network'],
        ['home.partners.heading', 'Heading', 'Trained partners\nnear you.', true],
        ['home.partners.button', 'Button', 'Partner program'],
    ] },
    { title: 'Home — FAQ & bottom banner', fields: [
        ['home.faq.eyebrow', 'FAQ small label', '/ Frequently asked'],
        ['home.faq.heading', 'FAQ heading', 'Buying, renting, training, parts —'],
        ['home.faq.accent', 'FAQ heading (orange part)', 'get the answers.'],
        ['home.faq.button', 'FAQ button', 'Read the FAQ'],
        ['home.cta.heading', 'Banner heading', 'Ready to blast with dry ice?'],
        ['home.cta.text', 'Banner text', 'Talk to a specialist about the right machine, a rental or financing with TimePayment.', true],
        ['home.cta.button1', 'Banner button 1', 'Shop Equipment'],
        ['home.cta.button2', 'Banner button 2', 'Finance with TimePayment'],
    ] },
    { title: 'Footer', fields: [
        ['footer.about', 'Company text', 'Authorized dry ice cleaning equipment dealer. Machines, accessories, parts, rentals and training — backed by 27+ years of hands-on industrial cleaning experience and a nationwide partner network.', true],
        ['footer.phone', 'Phone', '(984) 201-0767'],
        ['footer.email', 'Email', 'nc@dryicebulls.com'],
        ['footer.location', 'Location line', 'North Carolina • Nationwide equipment'],
        ['footer.copyright', 'Copyright line', '© 2026 Dry Ice Bulls Cleaning System® LLC. All rights reserved.'],
    ] },
];

export const SITE_TEXT_DEFAULTS = Object.fromEntries(SITE_TEXT_GROUPS.flatMap((g) => g.fields.map(([k, , d]) => [k, d])));

let cache = null;
let pending = null;
const listeners = new Set();
const load = () => {
    if (!pending) pending = api.get('/site-texts').then((r) => { cache = r.data || {}; listeners.forEach((fn) => fn(cache)); }).catch(() => { cache = {}; });
    return pending;
};
export const setSiteTextsCache = (texts) => { cache = texts; listeners.forEach((fn) => fn(cache)); };

export const useSiteTexts = () => {
    const [texts, setTexts] = useState(cache || {});
    useEffect(() => {
        listeners.add(setTexts);
        if (cache) setTexts(cache); else load();
        return () => listeners.delete(setTexts);
    }, []);
    return (key) => (texts[key] || '').trim() || SITE_TEXT_DEFAULTS[key] || '';
};

export const lines = (s) => s.split('\n').map((x) => x.trim()).filter(Boolean);
